export default __webpack_public_path__ + "static/media/PSICOLOGIA.b677514f.pdf";